import React from "react";
import { Typography } from "antd";
import { resolveOcrDpi, resolveOcrOptions } from "./OcrDpiSlider";

const { Text } = Typography;

export const OCR_RETRY_INTENT = Object.freeze({
    INHERIT: "inherit",
    HIGH_RESOLUTION: "high_resolution",
    STANDARD: "standard",
});

export const isHighResolutionPdfOcrPreferred = (source) => (
    Boolean(resolveOcrOptions(source)?.high_resolution_pdf_ocr)
);

export const getOcrModeRecoveryAction = (source) => {
    const usesHighResolution = isHighResolutionPdfOcrPreferred(source);
    return usesHighResolution
        ? {
            key: "ocr_mode_recovery",
            intent: OCR_RETRY_INTENT.STANDARD,
            label: "使用标准模式重新识别",
        }
        : {
            key: "ocr_mode_recovery",
            intent: OCR_RETRY_INTENT.HIGH_RESOLUTION,
            label: "使用高清模式重新识别",
        };
};

export const getOcrRetryOverride = (intent) => {
    if (intent === OCR_RETRY_INTENT.HIGH_RESOLUTION) return true;
    if (intent === OCR_RETRY_INTENT.STANDARD) return false;
    return undefined;
};

export const getOcrRetryPresentation = (intent, source) => {
    if (intent === OCR_RETRY_INTENT.HIGH_RESOLUTION) {
        return {
            title: "使用高清模式重新识别",
            modeLabel: "本次使用高清模式",
            description: "适用于扫描 PDF，处理速度较慢。该模式会保存为当前账单后续 OCR 的默认模式。",
        };
    }
    if (intent === OCR_RETRY_INTENT.STANDARD) {
        return {
            title: "使用标准模式重新识别",
            modeLabel: "本次切回标准模式",
            description: "该模式会保存为当前账单后续 OCR 的默认模式。",
        };
    }

    const usesHighResolution = isHighResolutionPdfOcrPreferred(source);
    return {
        title: "重新 OCR 识别",
        modeLabel: usesHighResolution ? "沿用当前高清模式" : "沿用当前标准模式",
        description: usesHighResolution
            ? "本次将沿用高清模式；调整清晰度会更新该账单后续 OCR 的默认值。"
            : "本次不会修改当前账单后续 OCR 的默认模式。",
    };
};

const OcrRetryModeNotice = ({ intent = OCR_RETRY_INTENT.INHERIT, ocrOptions, pdfRenderDpi }) => {
    const presentation = getOcrRetryPresentation(intent, ocrOptions);
    const showDpi = intent === OCR_RETRY_INTENT.HIGH_RESOLUTION
        || (intent === OCR_RETRY_INTENT.INHERIT && isHighResolutionPdfOcrPreferred(ocrOptions));
    const dpi = intent === OCR_RETRY_INTENT.HIGH_RESOLUTION || (intent === OCR_RETRY_INTENT.INHERIT && pdfRenderDpi !== undefined)
        ? resolveOcrDpi({ pdf_render_dpi: pdfRenderDpi })
        : resolveOcrDpi(ocrOptions);
    return (
        <div style={{ marginBottom: 16, padding: "8px 12px", background: "#fafafa", borderRadius: 4 }}>
            <Text strong>{presentation.modeLabel}</Text>
            <div>
                <Text type="secondary">{presentation.description}</Text>
            </div>
            {showDpi && (
                <div>
                    <Text type="secondary">渲染分辨率：{dpi} DPI</Text>
                </div>
            )}
        </div>
    );
};

export default OcrRetryModeNotice;
